import { useState } from 'react';
import { useSEO } from '../useSEO';

function ContactPage() {
  useSEO({
    title: 'Contact | Reset & Run',
    description: 'Get in touch with Ivy at Reset & Run to book a free consultation and start your home organisation journey.',
    path: '/contact',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'ContactPage',
      name: 'Contact | Reset & Run',
      url: 'https://www.resetandrun.com.au/contact',
      description: 'Get in touch with Ivy at Reset & Run to book a free consultation and start your home organisation journey.',
    },
  });
  const [status, setStatus] = useState('idle');

  async function handleSubmit(e) {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);
    setStatus('sending');
    try {
      const res = await fetch('https://formspree.io/f/xgodwdra', {
        method: 'POST',
        body: data,
        headers: { Accept: 'application/json' },
      });
      if (res.ok) {
        setStatus('sent');
        form.reset();
        setTimeout(() => setStatus('idle'), 5000);
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  }

  return (
    <main className="subpage">
      <section className="contact-form-section">
        <div className="contact-form-wrap">
          <h1>Get in Touch</h1>
          <p>Fill in the form below and I&apos;ll get back to you as soon as possible.</p>

          {status === 'sent' ? (
            <p className="contact-form__success">Thanks for your message! I&apos;ll be in touch soon.</p>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="contact-form__field">
                <label htmlFor="name">Name</label>
                <input id="name" type="text" name="name" required placeholder="Your name" />
              </div>
              <div className="contact-form__field">
                <label htmlFor="email">Email</label>
                <input id="email" type="email" name="email" required placeholder="your@email.com" />
              </div>
              <div className="contact-form__field">
                <label htmlFor="phone">Phone (optional)</label>
                <input id="phone" type="tel" name="phone" placeholder="04xx xxx xxx" />
              </div>
              <div className="contact-form__field">
                <label htmlFor="message">Message</label>
                <textarea id="message" name="message" required rows="5" placeholder="Tell me a bit about what you need help with..." />
              </div>
              <button type="submit" className="button button--nav contact-form__submit" disabled={status === 'sending'}>
                {status === 'sending' ? 'Sending…' : 'Send Message'}
              </button>
              {status === 'error' && (
                <p className="contact-form__error">Something went wrong. Please try again or email IvyResets@gmail.com directly.</p>
              )}
            </form>
          )}
        </div>
      </section>
    </main>
  );
}

export default ContactPage;
